import React from "react";
import {
  DocumentCard,
  DocumentCardDetails,
  DocumentCardTitle,
  DocumentCardActivity,
  DocumentCardLocation,
  Icon,
  TooltipHost,
  DefaultButton,
} from "@fluentui/react";
import { attentionMessages } from "../../GlobalConst/attentionMessages";
import { ProvisioningStatus, SiteStatus } from "../../GlobalConst/globalEnums";
import EditModal from "../EditSite/EditModal";
import InfoTooltip from "../formFields/InfoTooltip";

class SingleSite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  _onEditClick = () => {
    this.setState({ showModal: true });
  };

  _onLocationClick = (e) => {
    e.stopPropagation();
    e.preventDefault();

    window.open(e.target.href, "_blank");
  };

  _mapOwnerForPeople(user) {
    return [
      {
        name: user ? user.displayName : "",
      },
    ];
  }

  _closeModal = () => {
    //this.props.onModalClosed();
    this.setState({ showModal: false });
  };

  _getSiteStatus = (site) => {
    const isMsTeams = site.siteTemplate.siteType === "Team";

    return isMsTeams && site.siteStatus === "Deleted"
      ? "Archived"
      : site.siteStatus;
  };

  render() {
    var attentionIcon = null;
    var attentions = this.props.site.attentions.filter((a) => a.isValid);
    if (attentions.length) {
      const attentionText = attentions.map((a, i) => (
        <span key={i}>
          {attentionMessages[a.type]}
          <br />
        </span>
      ));
      attentionIcon = (
        <TooltipHost content={attentionText} styles={iconStyles}>
          <Icon iconName="important" style={attentionIconStyles} />
        </TooltipHost>
      );
    }

    var updatesIcon = null;
    if (
      [
        ProvisioningStatus.ready_display,
        ProvisioningStatus.readOnly_display,
        ProvisioningStatus.noAccess_display,
        ProvisioningStatus.permanentFailed_display,
        ProvisioningStatus.created_display,
      ].indexOf(this.props.site.provisioningStatus) < 0
    ) {
      updatesIcon = (
        <TooltipHost content="Updates are in progress" styles={iconStyles}>
          <Icon iconName="workflow" style={updatesIconStyles} />
        </TooltipHost>
      );
    } else {
      updatesIcon = null;
    }

    const toolTipContent = (
      <div>
        <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
          Reject reason:{" "}
        </div>
        <div style={{ width: "250px" }}>{this.props.site.approverComment}</div>
      </div>
    );

    const tooltip =
      this.props.site.siteStatus === "Rejected" ? (
        <InfoTooltip content={toolTipContent} />
      ) : null;

    var btnEdit = (
      <DefaultButton
        text="Edit"
        onClick={this._onEditClick}
        styles={btnEditStyles}
      />
    );
    // if (
    //   updatesIcon ||
    //   [
    //     SiteStatus.active,
    //     SiteStatus.deleted,
    //     SiteStatus.expired,
    //     SiteStatus.archived,
    //   ].indexOf(this.props.site.siteStatus) < 0
    // ) {
    //   btnEdit = null;
    // } else {
    //   return btnEdit;
    // }

    if (this.props.site.siteStatus === SiteStatus.disabled) {
      btnEdit = null;
    }

    return (
      <div>
        <DocumentCard styles={cardStyles}>
          <DocumentCardDetails styles={detailsStyles}>
            <div style={titleStyles}>
              <DocumentCardTitle
                title={this.props.site.title}
                shouldTruncate={false}
              />
              <div style={iconContainerStyles}>
                {attentionIcon}
                {updatesIcon}
                {btnEdit}
              </div>
            </div>
            {this.props.site.url &&
              this.props.site.siteStatus !== SiteStatus.creating && (
                <DocumentCardLocation
                  styles={urlStyles}
                  location={this.props.site.url}
                  locationHref={this.props.site.url}
                  onClick={this._onLocationClick}
                />
              )}
            <div style={statusStyles}>
              {"Status: " + this._getSiteStatus(this.props.site)} {tooltip}
            </div>
            <div style={createdByStyles}>Created by: </div>
          </DocumentCardDetails>
          <DocumentCardActivity
            activity={`Created on ${new Date(
              this.props.site.created + "Z"
            ).toLocaleString()}`}
            people={this._mapOwnerForPeople(this.props.site.author)}
          />
        </DocumentCard>
        <EditModal
          onCloseModal={this._closeModal}
          isModalOpened={this.state.showModal}
          editedSite={this.props.site}
          callBack={this.props.callBack}
        />
      </div>
    );
  }
}
const urlStyles = {
  root: {
    color: "rgb(0, 120, 212)",
  },
};
const statusStyles = {
  padding: "8px 16px",
  fontSize: "12px",
};

const createdByStyles = {
  padding: "8px 16px 0",
  fontSize: "12px",
};

const btnEditStyles = {
  root: {
    margin: "6px",
    height: "24px",
    minWidth: "40px",
  },
  label: {
    fontWeight: 400,
  },
};

const iconContainerStyles = {
  display: "flex",
};

const iconStyles = {
  root: {
    margin: "10px 10px 10px 0",
  },
};

const attentionIconStyles = {
  color: "red",
};

const updatesIconStyles = {
  color: "orange",
};

const titleStyles = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
};

const cardStyles = {
  root: {
    marginRight: 20,
    marginBottom: 20,
    width: 400,
  },
};

const detailsStyles = {
  root: {
    height: 140,
  },
};

export default SingleSite;



// WEBPACK FOOTER //
// ./src/components/ManageCenter/SingleSite.js